<template>
  <div class="general-select">
    <el-tag v-for="item in value" :key="item.id" size="medium" :closable="!disabled" :disable-transitions="false"
      @close="handleCloseItem(item)">{{dealWithTitle(item.name)}}</el-tag>
    <el-button circle class="general-select-addButton" icon="el-icon-plus" size="small" @click="addGeneral" />
    <!-- 通用选择器 弹窗 -->
    <el-dialog class="avue-dialog" :title="`${generalSelectTargetName} 选择`" :visible.sync="generalSelectShow"
      :append-to-body="true" width="50%" top="10vh">
      <!-- 选择器主体 -->
      <el-row :gutter="20">
        <el-col :span="isSingle?24:12">
          <div class="general-select-toChoose">
            <div class="general-select-title">
              <p>选择:</p>
            </div>
            <div class="general-select-content choose-main">
              <!-- 条件搜索 -->
              <div class="choose-main-search">
                <el-input size="small" :placeholder="`请输入 ${generalSelectTargetName} 名称`"
                  v-model="searchForm.searchValue" :clearable="true">
                  <el-select slot="prepend" style="width:100px;" v-model="searchForm.searchmodel" placeholder="请选择">
                    <el-option label="当前" :value="true"></el-option>
                    <el-option label="全局" :value="false"></el-option>
                  </el-select>
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  <el-button slot="append" type="primary" size="small" @click="loadGeneralFromService" circle
                    icon="el-icon-search"></el-button>
                </el-input>
              </div>
              <!-- 选择路径 -->
              <div class="choose-main-path">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item v-for="item in generalPath" :key="item.permissionSubjectId"
                    class="choose-main-path-active"><span
                      @click="toBreadcrumbPath(item)">{{item.name}}</span></el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <!-- 选择主体 -->
              <div class="choose-main-main " v-loading="loadGeneralFromServiceController" element-loading-text="拼命加载中">
                <div class="choose-main-main-item" v-for="(item,index) in toChooseData" :key="index">
                  <el-checkbox @change="chooseItemChange(item)" v-model="item.checked"
                    class="choose-main-main-item-checkbox"> <i class="fa fa-folder"></i> {{item.name}} </el-checkbox>
                  <div class="choose-main-main-item-toLowerLevel" @click="toLowerLevel(item)">
                    <i class="fa fa-arrow-circle-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12" v-if="!isSingle">
          <div class="general-select-hasChoose">
            <div class="general-select-title">
              <p>{{`已选: ${value.length}/${islimitMax?'∞':max}`}}</p>
            </div>
            <div class="general-select-content ">
              <div class="choose-main-main-item" v-for="(item,index) in value" :key="index">
                <div class="choose-main-main-item-title"><i class="fa fa-folder"></i> {{item.name}}</div>
                <div class="choose-main-main-item-toLowerLevel" @click="handleCloseItem(item)">
                  <i class="fa fa fa-times-circle"></i>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="this.generalSelectShow = false" >关 闭</el-button>
     <el-button type="primary" @click="handleSelectSubmit()">提 交</el-button>
    </span> -->
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loadGeneralFromServiceController: false,
      searchForm: {
        searchValue: '',
        searchmodel: true
      },
      generalSelectShow: false,
      generalPath: [{
        permissionSubjectId: '',
        id: '',
        name: '树根'
      }],
      toChooseData: []
    }
  },
  props: {
    // 已经选择的对象
    value: {
      type: Array,
      default: () => []
    },
    // 最大选择数量
    max: {
      type: Number,
      default: 1,
      validator: value => (value >= 0)
    },
    // 选择类型
    type: {
      type: String,
      default: 'role',
      validator: value => ['role', 'organ'].includes(value)
    },
    // 已经选择的对象
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 是否单选
    isSingle() {
      return this.max === 1
    },
    // 是否限制最大选择
    islimitMax() {
      return this.max === 0
    },
    // 标题计算
    generalSelectTargetName() {
      switch (this.type) {
        case 'role':
          return '角色'
        case 'organ':
          return '机构'
        default:
          return '非法的选择类型'
      }
    },
    interfaceAddress() {
      switch (this.type) {
        case 'role':
          return '/role/list'
        case 'organ':
          return '/org/list'
        default:
          return 'Illegal selection type'
      }
    }

  },
  components: {},

  methods: {
    /** 获取标题,标题过长进行省略号处理 */
    dealWithTitle(title) {
      if (title) {
        if (title.length > 10) {
          return `${title.substring(0, 10)}...`
        } else {
          return title
        }
      } else {
        return '名称缺省'
      }
    },
    /** 检测到用户关闭某些选项 */
    handleCloseItem(item) {
      item.checked = false
      this.value.splice(
        this.value.findIndex(i => i.id === item.id),
        1
      )
      this.refreshCheackbox()
      this.$emit('input', this.value)
    },
    /** 添加 通用对象 */
    addGeneral() {
      if (!this.disabled) {
        this.refreshCheackbox()
        this.loadGeneralFromService()
        this.generalSelectShow = true
      }
    },
    /** 访问下级 */
    toLowerLevel(item) {
      // 访问下级的时候,将搜索条件置空并修改搜索模式
      this.searchForm.searchmodel = true
      this.searchForm.searchValue = ''
      this.generalPath.push(item)
      this.loadGeneralFromService()
    },
    /** 重服务器加载实体信息 */
    loadGeneralFromService() {
      this.loadGeneralFromServiceController = true
      this.$http.post(this.interfaceAddress, {
        'entity': {
          'parentPermissionSubjectId': this.searchForm.searchmodel ? this.generalPath[this.generalPath.length - 1].permissionSubjectId : null,
          name: this.searchForm.searchValue
        }
      }).then(response => {
        this.loadGeneralFromServiceController = false
        let hasChooseIdList = this.value.map(item => item.id)
        response.data.forEach(item => {
          item.checked = hasChooseIdList.includes(item.id)
        })
        this.toChooseData = response.data
      }).catch(error => {
        this.loadGeneralFromServiceController = false
        this.toChooseData = []
        this.$message.error(error.msg || error.message)
      })
    },
    /** 刷新已选状态 */
    refreshCheackbox() {
      if (!Array.isArray(this.value)) {
        this.value = []
      }
      let hasChooseIdList = this.value.map(item => item.id)
      this.toChooseData.forEach(item => {
        item.checked = hasChooseIdList.includes(item.id)
      })
    },
    // 面包屑跳级
    toBreadcrumbPath(item) {
      let index = this.generalPath.findIndex(i => i.permissionSubjectId === item.permissionSubjectId)
      if (this.generalPath.length - 1 !== index) {
        this.generalPath.splice(index + 1, this.generalPath.length - index + 1)
        this.loadGeneralFromService()
      }
    },
    /** 单个item 选择改变的时候 */
    chooseItemChange(item) {
      // 选择
      if (item.checked) {
        if (this.isSingle) {
          // 单选
          this.value = [item]
        } else {
          if (!this.islimitMax) {
            // 限制最大选择数量
            if (this.value.length >= this.max) {
              item.checked = !item.checked
              this.refreshCheackbox()
              return this.$message.error('超过最大选择数量。')
            } else {
              this.value.push(item)
            }
          } else {
            // 不限制最大选择数量
            this.value.push(item)
          }
        }
      } else {
        // 取消选择
        this.value.splice(this.value.findIndex(i => i.id === item.id), 1)
      }
      this.refreshCheackbox()
      this.$emit('input', this.value)
    }

  }
}
</script>
<style lang="scss" scoped>
:deep(.el-dialog__body) {
  padding: 0.625rem 1.25rem 875rem 1.25rem;
}

.general-select {
  :deep(.el-tag) {
    margin-left: 0.625rem;
  }
  width: 100%;
  font-size: 0.875rem;
  line-height: 2.5rem;
  border-radius: 5px;
  background-color: transparent;
  border: 1px solid #dcdfe6;
  &-title {
    font-size: 1.125rem;
    font-weight: 600;
    p {
      margin: 0;
      padding: 3px 5px;
    }
  }
  &-content {
    background: rgb(245, 246, 249);
    padding: 5px 5px;
    height: calc(100% - 24px);
    overflow: scroll;
    border-radius: 5px;
  }
  &-toChoose {
    width: 100%;
    height: 25rem;
  }
  &-hasChoose {
    width: 100%;
    height: 25rem;
  }
  &-addButton {
    margin-left: 0.625rem;
  }
}

.choose-main {
  padding: 5px;
  &-path {
    &-active:hover {
      background: rgb(255, 255, 255);
    }
    font-size: 1.125rem;
    padding: 5px;
    .el-breadcrumb__item {
      padding: 5px 0px;
      cursor: pointer;
    }
  }
  &-main {
    min-height: 25rem;
    &-item {
      &-title {
        font-size: 0.875rem;
        display: inline-block;
        width: calc(100% - 2.1875rem);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      cursor: pointer;
      &:hover {
        background: rgb(255, 255, 255);
      }
      &-checkbox {
        width: calc(100% - 2.1875rem);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      height: 1.875rem;
      line-height: 1.875rem;
      font-size: 1.25rem;
      &-toLowerLevel {
        float: right;
        width: 1.875rem;
        white-space: nowrap;
        overflow: hidden;
        text-align: center;
      }
    }
  }
}
</style>
